import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadSubmission } from '../actions';
import Canvas from './Canvas';
import { URLS } from '../constants';

const mapStateToProps = state => ({
  submission: state.submission,
  num_questions: state.questions.length
});

const mapDispatchToProp = dispatch => ({
  onLoad: () => {
    dispatch(loadSubmission());
  }
});

class Result extends React.Component {
  constructor(props) {
    super(props);
    this.freqLoad = null;
  }

  componentDidUpdate() {
    const { submission, onLoad } = this.props;
    if (!submission || !submission.submitted) { 
      clearInterval(this.freqLoad);
    } else if (!this.freqLoad) {
      this.freqLoad = setInterval(onLoad, 10000);
    }
  }

  render() {
    const { submission, num_questions } = this.props;

    if (!submission || !submission.submitted) { return null; }

    const num_correct = `(${submission.num_correct}/${num_questions})`;

    const winner = submission.win ? (
      <div>
        <h1>You Win!</h1>  
        <h1 className="score"><i className="fa fa-trophy" /></h1>                     
        <h2>{`Your Score: ${submission.score} ${num_correct}`}</h2>
      </div>
    ) : null;

    const result = submission.score ? (
      <div>
        <h2>Your Score</h2>
        <h1 class="score">{ submission.score }</h1> 
        <h2>{ num_correct }</h2>
      </div>
    ) : null;

    const pending = (
      <div>
        <h2>THANK YOU</h2>
        <h3><strong>The winner will be announced soon.<br />Come back to this page to check if you win.</strong></h3>        
      </div>
    );

    return (
      <Canvas spanClass="span6 offset1">
        <center>
          { winner || result || pending }
          <h3>Thank you for playing!</h3> 
          <p>&nbsp;</p>                       
          <p className="actions"><a href={ URLS.slideshow }><i className="fa fa-play-circle" aria-hidden="true" /><br />Check out the Slideshow</a></p>
        </center>
      </Canvas>
    );
  }
}

Result.propTypes = {
  submission: PropTypes.object,
  num_questions: PropTypes.number,
  onLoad: PropTypes.func
};

const ResultContainer = connect(
  mapStateToProps,
  mapDispatchToProp
)(Result);

export default ResultContainer;


// WEBPACK FOOTER //
// ./src/components/Result.js